__turbopack_context__.v({
  "arrow": "MobileSidebarToggle-module-scss-module__TWg4BG__arrow",
  "isCollapsed": "MobileSidebarToggle-module-scss-module__TWg4BG__isCollapsed",
  "jump": "MobileSidebarToggle-module-scss-module__TWg4BG__jump",
  "mobileToggle": "MobileSidebarToggle-module-scss-module__TWg4BG__mobileToggle",
  "point-to": "MobileSidebarToggle-module-scss-module__TWg4BG__point-to",
  "standard": "MobileSidebarToggle-module-scss-module__TWg4BG__standard",
});
